/** @format */

import {
  Button,
  Loading,
  Modal,
  TextInput,
  Tile,
} from "carbon-components-react";
import { useEffect, useState } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UIShell from "../../components/UIShell";
import UIShellPagination from "../../components/UIShellPagination";
import PageHelper from "../../helpers/Pagehelper";
import {
  bulkDeleteCategory,
  fetchAllCategory,
  updateCategory,
} from "../../redux/actions/categoryAction";
import CategoryChildPage from "./CategoryChildPage";

function CategoryPage({ isLoading }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [isLoadingData, setIsLoadingData] = useState(true);

  const [paginationContent, setPaginationContent] = useState({
    query: "",
    page: 0,
    limit: 20,
    total: 0,
    totalItems: 0,
    rows: [],
  });

  const [modalContent, setModalContent] = useState({
    modalHeading: "",
    isOpen: false,
    categoryId: undefined,
    categoryName: undefined,
  });

  const headers = [
    {
      key: "categoryName",
      header: "Category Name",
    },
    {
      key: "thumbnail",
      header: "Thumbnail",
    },
  ];

  const mapToColumn = (row) => {
    return {
      _id: row._id,
      categoryName: row.categoryName,
      thumbnail: (
        <img
          src={row.thumbnail}
          style={{
            width: 100,
            margin: "0 10px 0 0",
            borderRadius: 5,
          }}
        />
      ),
    };
  };

  const updateCategoryDetail = () => {
    dispatch(
      updateCategory(
        {
          categoryId: modalContent.categoryId,
          categoryName: modalContent.categoryName,
        },
        () => {
          // reset modal content
          setModalContent({
            modalHeading: "",
            isOpen: false,
            categoryId: undefined,
            categoryName: undefined,
          });

          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const bulkDelete = async (_items) => {
    dispatch(
      bulkDeleteCategory(
        {
          categoryIds: _items.map((v) => ({
            _id: v.id,
          })),
        },
        () => {
          fetch({ query: "", page: 0, limit: paginationContent.limit });
        }
      )
    );
  };

  const viewCategoryDetail = (_data) => {
    const categoryId = _data[0].id.split(":")[0];
    const categoryName = _data.filter(
      (v) => v.info.header === "categoryName"
    )[0]?.value;

    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${categoryName}`,
      categoryId,
      categoryName,
    }));
  };

  const viewCategoryChildDetail = ({ categoryId, categoryName }) => {
    setModalContent((v) => ({
      isOpen: true,
      modalHeading: `${categoryName}`,
      categoryId,
      categoryName,
    }));
  };

  const paginationChange = async (_newPage) => {
    fetch({
      query: paginationContent.query,
      page: _newPage,
      limit: paginationContent.limit,
    });
  };

  const searchTable = async (e) => {
    const { value } = e.target;

    fetch({ query: value, page: 0, limit: paginationContent.limit });
  };

  const fetch = ({ query, page, limit }) => {
    setIsLoadingData(true);
    dispatch(
      fetchAllCategory(
        { query, page, limit },
        ({ filteredData, totalFiltered, total }) => {
          setPaginationContent((v) => ({
            ...v,
            skip: totalFiltered,
            query,
            limit,
            page,
            total,
            totalItems: PageHelper.getTotalItems(total, limit),
            rows: filteredData.map(mapToColumn),
          }));
          setIsLoadingData(false);
        }
      )
    );
  };

  useEffect(() => {
    fetch(paginationContent);
  }, []);

  return (
    <UIShell
      breadcrumbs={[{ name: "Home", link: "/" }, { name: "Categories" }]}
    >
      {isLoadingData && <Loading />}
      <UIShellPagination
        dataTableList={paginationContent.rows}
        headers={headers}
        searchTable={searchTable}
        bulkDelete={bulkDelete}
        createForm={() => history.push("/categories/form")}
        viewDetail={viewCategoryDetail}
        paginationChange={paginationChange}
        totalItems={paginationContent.totalItems}
        page={paginationContent.page}
        withExpander={true}
      />

      <Modal
        modalHeading={modalContent.modalHeading}
        modalLabel="Category details"
        primaryButtonText="Update"
        primaryButtonDisabled={isLoading}
        secondaryButtonText="Cancel"
        open={modalContent.isOpen}
        onRequestSubmit={() => updateCategoryDetail()}
        onRequestClose={() => setModalContent((v) => ({ ...v, isOpen: false }))}
      >
        <p style={{ marginBottom: "1rem" }}>
          Category can be nested up to 3 levels
        </p>

        <TextInput
          data-modal-primary-focus
          labelText="Category Name"
          placeholder="e.g. github.com"
          value={modalContent.categoryName}
          onChange={(_v) =>
            setModalContent((v) => ({ ...v, categoryName: _v.target.value }))
          }
          style={{ marginBottom: "1rem" }}
        />

        <Button
          onClick={() =>
            history.push(`/categories/${modalContent.categoryId}/image`)
          }
        >
          Change image
        </Button>

        {modalContent.isOpen && (
          <CategoryChildPage
            onViewCategoryDetail={viewCategoryChildDetail}
            categoryParentId={modalContent.categoryId}
            categoryParentName={modalContent.categoryName}
            isLoading={isLoading}
          />
        )}
      </Modal>
    </UIShell>
  );
}

const mapStateToProps = (state) => {
  return {
    dataTableList: state.categoryReducer.dataTableList,
    isLoading: state.uxReducer.isLoading,
  };
};

export default connect(mapStateToProps)(CategoryPage);
